import { useContext, useMemo } from 'react'
import { queryCurrentMediaSelectionWithFallback } from '../Logic'
import { UserContext, UserContextType } from '../UserContext'

export default function useMediaSelectionViews() {
    const { state } = useContext(UserContext) as UserContextType

    const mediaSelectionWithDefault = useMemo(() => {
        return {
            audioOutput: queryCurrentMediaSelectionWithFallback(
                state.mediaSelection,
                state.mediaSources,
                'audioOutput'
            ),
            audioOutputMuseRecording: queryCurrentMediaSelectionWithFallback(
                state.mediaSelection,
                state.mediaSources,
                'audioOutputMuseRecording'
            ),
            desktop: queryCurrentMediaSelectionWithFallback(state.mediaSelection, state.mediaSources, 'desktop'),
            video: queryCurrentMediaSelectionWithFallback(state.mediaSelection, state.mediaSources, 'audioOutput'),
            midiInput: queryCurrentMediaSelectionWithFallback(state.mediaSelection, state.mediaSources, 'midiInput'),
            midiOutput: queryCurrentMediaSelectionWithFallback(state.mediaSelection, state.mediaSources, 'midiOutput'),
            midiPassthroughOutput: queryCurrentMediaSelectionWithFallback(
                state.mediaSelection,
                state.mediaSources,
                'midiPassthroughOutput'
            ),
        }
    }, [state.mediaSelection, state.mediaSources])

    const audioOutputSelectionInfo = useMemo(() => {
        return state.mediaSources.audioOutputs.find((a) => a.deviceId === state.mediaSelection.audioOutput) || null
    }, [state.mediaSources.audioOutputs, state.mediaSelection.audioOutput])

    return {
        mediaSelectionWithDefault,
        audioOutputSelectionInfo,
    }
}
